<template>
  <router-view name="view"></router-view>
</template>
<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
  },
})

export default class Authentication extends Vue {
}
</script>
